@if (loadingService.isLoading()) {
<div class="container-loading-operation" role="status" aria-live="polite" aria-busy="true">
  <div class="loading-operation">
    @for (i of squares; track i) {
      <div class="square" [style.animation-delay.s]="i * 0.1"></div>
    }
  </div>
</div>
}